export default "__VITE_ASSET__CiFJ0AOP__"